import { FC } from "react";
import { IObject } from "toolkit/steps/stepSeven/stepSeven.types";
import { ObjectSeventhStep } from "../ObjectSeventhStep/ObjectSeventhStep";
import styles from "./List.module.sass";

interface ListProps {
	dataList: IObject[];
	title?: string;
	type: string;
}

export const List: FC<ListProps> = ({ dataList, title, type }) => {
	return (
		<>
			<div data-comment-false={true} className={styles["list-wrp"]}>
				<div className={styles["list-header"]}>
					<span className={styles.title}>{title}</span>
				</div>
				<div className={styles.list}>
					{dataList.map((item) => (
						<ObjectSeventhStep key={item.id} object={item} type={type} />
					))}
				</div>
			</div>
		</>
	);
};
